<template>
  <div>
    <van-cell is-link :title="val" @click="show = true" />
    <van-action-sheet v-model="show" :actions="actions" @select="select" />
  </div>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: '请选择'
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    },
    labelAttr: {
      type: String,
      default: 'name'
    },
    valueAttr: {
      type: String,
      default: 'id'
    }
  },
  data() {
    return {
      show: false,
      val: this.value || '',
      actions: this.options
    }
  },
  watch: {
    value: function(value) {
      this.val = value || ''
    },
    options: function(options) {
      this.actions = options
    }
  },
  methods: {
    select(action) {
      this.$emit('change', action[this.labelAttr], action)
      this.show = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseSelect.vue